import { createContext, useContext } from "react";

/**
 * Estado del Panel General de Módulos — provisto por Layout, consumido en Dashboard.
 * Evita duplicar lógica entre el shell y el Panel General embebido.
 */
const WorkModuleContext = createContext(null);

export function WorkModuleProvider({ value, children }) {
  return (
    <WorkModuleContext.Provider value={value}>
      {children}
    </WorkModuleContext.Provider>
  );
}

export function useWorkModulePanel() {
  return useContext(WorkModuleContext);
}
